import React, { useState, useEffect } from 'react';
import StackedBarChart from './StackedBarChart';
import projectAssessmentProgressBySubsidiaryCompaniesService from './project_assessment_progress_by_subsidiary_companies.service';
const ProjectAssessmentProgressBySubsidiaryCompany = _ref => {
  let {
    filteredBusinessUnits,
    companyId,
    selectedYears,
    selectedSubsidiaryCompanyIds
  } = _ref;
  const [chartData, setChartData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const buParam = filteredBusinessUnits.map(bu => bu.business_unit_id).join(',');
      const scParam = selectedSubsidiaryCompanyIds.join(',');
      const data = await projectAssessmentProgressBySubsidiaryCompaniesService.all(companyId, buParam, scParam, selectedYears);
      setChartData(data);
    };
    fetchData();
  }, [companyId, filteredBusinessUnits, selectedSubsidiaryCompanyIds]);
  const categories = chartData.map(d => d.subsidiary_company_name);
  const series = [{
    name: 'Completed',
    data: chartData.map(d => d.completed_count)
  }, {
    name: 'In Progress',
    data: chartData.map(d => d.in_progress_count)
  }, {
    name: 'Not Started',
    data: chartData.map(d => d.not_started_count)
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card dashboard-card-group-chart"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-center dashboard-regular-card-title"
  }, "Project Assessment Progress"), /*#__PURE__*/React.createElement(StackedBarChart, {
    series: series,
    categories: categories,
    colors: ['#00afef', '#0078b9', '#00b08b']
  }));
};
export default ProjectAssessmentProgressBySubsidiaryCompany;